import React from 'react';
import { Card, Col, Row } from 'reactstrap';
import foodImg from '../../assets/images/food.svg';
import transportImg from '../../assets/images/transportation.svg';
import healthImg from '../../assets/images/clinical.svg';
import employmentImg from '../../assets/images/employment.svg';
import financeImg from '../../assets/images/finance.svg';
import houseImg from '../../assets/images/housing.svg';
import otherImg from '../../assets/images/others.svg';
import eduImg from '../../assets/images/education.svg';
import wifiImg from '../../assets/images/wifi.svg';
import legalImg from '../../assets/images/legal.svg';

import caregiver from '../../assets/icons/Caregiver.svg';
import clinical from '../../assets/icons/Clinical.svg';
import digital from '../../assets/icons/Digital.svg';
import employment from '../../assets/icons/Employment.svg';
import financial from '../../assets/icons/Financial.svg';
import food from '../../assets/icons/Food.svg';
import housing from '../../assets/icons/Housing.svg';
import interpersonal from '../../assets/icons/Interpersonal.svg';
import legal from '../../assets/icons/Legal.svg';
import literacy from '../../assets/icons/Literacy.svg';
import other from '../../assets/icons/Other.svg';
import social from '../../assets/icons/Social.svg';
import transportation from '../../assets/icons/Transportation.svg';
import physicalSafety from '../../assets/icons/physicalSafety.svg';
import { dateInRequireFormate } from '../../utils/Utils';

const GoalsInfoPdf = ({ dataForPDf, Content }) => {
    const disclaimerMargin = {
        marginTop: '5%'
    };

    const fontItalic = {
        fontStyle: 'italic'
    };

    const textColor = {
        color: '#25676D'
    };

    const orgColor = {
        color: ' #495057'
    };

    const textWrap = {
        wordBreak: 'break-word'
    };

    const iconSuze = {
        height: '30px',
        marginRight: '5px',
        marginBottom: '8px'
    };

    const handleCatgIcon = (item) => {
        if (!item) return other; // Handle undefined/null input

        switch (true) {
            case item.includes('Clinical'):
                return clinical;
            case item.includes('Financial'):
                return financial;
            case item.includes('Employment'):
                return employment;
            case item.includes('Transportation'):
                return transportation;
            case item.includes('Housing'):
                return housing;
            case item.includes('Literacy'):
                return literacy;
            case item.includes('Physical'):
                return physicalSafety;
            case item.includes('Caregiver'):
                return caregiver;
            case item.includes('Food'):
                return food;
            case item.includes('Legal'):
                return legal;
            case item.includes('Interpersonal'):
                return interpersonal;
            case item.includes('Digital'):
                return digital;
            case item.includes('Social'):
                return social;
            case item.includes('Other'):
            default:
                return other;
        }
    };

    return (
        <>
            <div className="px-4">
                {dataForPDf?.needDetailsTypes?.length > 0 ? (
                    dataForPDf.needDetailsTypes.map((item, idx) => (
                        <div key={idx}>
                            <Card className="p-3 rounded">
                                <div className="d-flex justify-content-between align-items-center border-bottom">
                                    <div className="d-flex align-items-center">
                                        <img src={handleCatgIcon(item?.needCategory)} alt="" className="text-primary" style={iconSuze} />
                                        <div className="m-0 fs-2 font-weight-bold text-success mb-1 ml-3">{item?.needCategory}</div>
                                    </div>
                                </div>
                                <div className="mt-3">
                                    {item.programs.length > 0 ? (
                                        item?.programs?.map((program, i) => (
                                            <>
                                                <Card className="p-2 rounded">
                                                    <div
                                                        className={`d-flex justify-content-between align-items-center ${
                                                            program.serviceOrganizations.length > 0 ? 'border-bottom' : 'border-bottom'
                                                        } `}
                                                    >
                                                        <div className="d-flex align-items-center">
                                                            <div className="m-0 fs-3 font-weight-bold" style={textColor}>
                                                                {program?.programName ? program?.programName : '-'}
                                                            </div>
                                                        </div>
                                                    </div>
                                                    {program?.serviceOrganizations?.length > 0 ? (
                                                        <Row className="p-1 mt-1">
                                                            {program.serviceOrganizations.map((ele, index) => (
                                                                <Col xl={6} lg={6} md={6} key={index} className="border-right mt-1">
                                                                    <div>
                                                                        <div className="m-0 fs-4 font-weight-bold" style={orgColor}>
                                                                            {ele?.serviceOrganizationName}
                                                                        </div>
                                                                    </div>
                                                                    <div className="d-flex align-items-center">
                                                                        <i className="ri-map-pin-fill text-danger fs-2"></i>
                                                                        <div className="fs-4 ml-5">
                                                                            {ele?.location ? ele?.location : '-'}
                                                                        </div>
                                                                    </div>
                                                                    <div className="d-flex align-items-center mt-2">
                                                                        <i className="ri-phone-fill text-success fs-2"></i>
                                                                        <p className="fs-4 m-0 ml-5">{ele?.phone ? ele?.phone : '-'}</p>
                                                                    </div>
                                                                    <div className="d-flex align-items-center mt-2">
                                                                        <i className="ri-mail-fill text-warning fs-2"></i>
                                                                        <p className="fs-4 m-0 ml-5" style={textWrap}>
                                                                            {ele?.email ? ele?.email : '-'}
                                                                        </p>
                                                                    </div>
                                                                    <div className="d-flex align-items-center mt-2">
                                                                        <i className="ri-global-fill text-info fs-2"></i>
                                                                        <a
                                                                            href={
                                                                                ele?.website?.startsWith('http')
                                                                                    ? ele?.website
                                                                                    : `http://${ele?.website}`
                                                                            }
                                                                            className="fs-4 m-0 ml-5 text-info"
                                                                            target="_blank"
                                                                            rel="noopener noreferrer"
                                                                            style={textWrap}
                                                                        >
                                                                            {ele?.website || '-'}
                                                                        </a>
                                                                    </div>
                                                                    <div className="d-flex align-items-center mt-2">
                                                                        <i className="ri-calendar-line text-success fs-2"></i>
                                                                        <p className="fs-4 m-0 ml-5">
                                                                            {ele?.pcpAppointmentDate
                                                                                ? dateInRequireFormate(
                                                                                      ele?.pcpAppointmentDate,
                                                                                      'm/d/y/hh:mm'
                                                                                  )
                                                                                : '-'}
                                                                        </p>
                                                                    </div>
                                                                    <div className="d-flex align-items-center mt-2">
                                                                        <i className="ri-sticky-note-line text-info fs-2"></i>
                                                                        <p className="fs-4 m-0 ml-5" style={textWrap}>
                                                                            {ele?.notes ? ele?.notes : '-'}
                                                                        </p>
                                                                    </div>
                                                                </Col>
                                                            ))}
                                                        </Row>
                                                    ) : (
                                                        <div className="p-2 text-center">
                                                            {Content?.noContent?.map((item, index) => (
                                                                <>
                                                                    <div>{item?.content}</div>
                                                                </>
                                                            ))}
                                                        </div>
                                                    )}
                                                </Card>
                                            </>
                                        ))
                                    ) : (
                                        <div className="p-2 text-center">
                                            {Content?.noContent?.map((item, index) => (
                                                <>
                                                    <div>{item?.content}</div>
                                                </>
                                            ))}
                                        </div>
                                    )}
                                </div>
                            </Card>
                        </div>
                    ))
                ) : (
                    <div className="p-5 text-center">
                        <div className="p-2 text-center">
                            {Content?.noContent?.map((item, index) => (
                                <>
                                    <div>{item?.content}</div>
                                </>
                            ))}
                        </div>
                    </div>
                )}
            </div>
            <div style={disclaimerMargin}></div>
            <div>
                {Content?.desclaimer?.map((item, index) => (
                    <>
                        <div className="mb-1">
                            <p className="px-4" style={item.style || {}}>
                                {item?.header && <span>{item?.header}</span>}
                            </p>
                            <p className="px-4">{item?.content}</p>
                        </div>
                    </>
                ))}
            </div>
        </>
    );
};

export default GoalsInfoPdf;
